import React, { useState } from "react";
import AuthCard from "../../shared/components/CustomCards";
import { CustomInput, CustomPassword } from "../../shared/components/AllInputs";
import PrimaryButton from "../../shared/components/CustomButtons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import formValidation from "../../utils/validations";
import { showFormErrors } from "../../utils/commonFunctions";
import { requestOTPAction } from "../../store/actions/auth.actions";

export default function Register() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    email: "",
    fullName: "",
    password: "",
    confirmPassword: "",
    otpType: 1,
  });

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const register = () => {
    if (showFormErrors(data, setData)) {
      dispatch(
        requestOTPAction(data, setLoading, () =>
          navigate("/auth/verify-account", { state: data })
        )
      );
    }
  };

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard heading={"Create an account"}>
        <CustomInput
          label="Full Name"
          name="fullName"
          placeholder="Full Name"
          col={12}
          data={data}
          onChange={handleChange}
        />
        <CustomInput
          label="Email"
          name="email"
          placeholder="Email"
          col={12}
          data={data}
          onChange={handleChange}
        />
        <CustomPassword
          label="Password"
          name="password"
          placeholder="Password"
          col={12}
          data={data}
          onChange={handleChange}
        />
        <CustomPassword
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Confirm password"
          col={12}
          data={data}
          onChange={handleChange}
        />

        <PrimaryButton
          label="Create account"
          loading={loading}
          extraClassNames="w-full mt-3"
          onClick={register}
        />
        <p className="text-sm font-medium heading text-center mt-5">
          Don't have an account yet?{" "}
          <Link
            to={"/auth/login"}
            className="no-underline primary-color font-bold"
          >
            Sign In
          </Link>{" "}
        </p>
      </AuthCard>
    </div>
  );
}
